import { IconButton } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { CrossIcon } from '@uplift/icons';
import { Tooltip } from '@uplift/ui-v2';

export type NoteSectionCloseButtonProps = {
  onDelete: () => void;
  closeIcon: boolean;
};

export const NoteSectionCloseButton: React.VFC<NoteSectionCloseButtonProps> = ({ onDelete, closeIcon }) => {
  return (
    <Tooltip title="Remove Section" placement="bottom">
      <IconButton
        onClick={onDelete}
      >
        {closeIcon ? <CrossIcon /> : <DeleteOutline />}
      </IconButton>
    </Tooltip>
  );
};
